import React from 'react';
import './Searchnav.css';
import WelcomeName from './WelcomeName';
import Autocomplete from "./AutoComplete";

function Searchnav() {
    return (
        <>
        <div role="region" aria-label="skip navigation">
            <a href="#main" class="cmp-skip-link">Skip to main content</a>
            {/* <a href="#footer" class="cmp-skip-link">Skip to footer</a> */}
            </div>
            <div class="searchnav-container">
                <div class="searchnav-wrap">
                    <div class="searchnav-row">
                        <div class="searchnav-box logoBlock" style={{ textAlign: 'left', marginTop: '0px' }}>
                            <div tabIndex={0}>
                            <img src="images/Acc_Logo_Black_Purple_RGB.png" class="acc-logo" alt="Accenture logo"/>
                            </div>
                            
                            <p class="desktop-tag"><a href="https://atci.lkm.accenture.com/newhome"> Learning and Knowledge Management, ATCI</a></p>
                            <p class="mobile-tag"><a href="https://atci.lkm.accenture.com/newhome"> LKM</a></p>
                        </div>
                    </div>
                    <div class="searchnav-row">
                        <div class="searchnav-box userBlock" style={{ textAlign: 'right', marginTop: '5px' }}>
                            <Autocomplete />
                            <div className='userRow'>
                            <WelcomeName />
                            {/* <div className="tooltips">
                                <img src="images/Avatar.png" class="user-img" alt="user-image" />
                                <span class="tooltiptext first">Avatar</span>
                            </div> */}
                            <img src="images/Avatar.png" class="user-img" alt="user-image" />
                            {/* <div className="tooltips">
                                <img src="images/Home/Search-icon.png" class="all-three-icons" alt="user-image" />
                                <span class="tooltiptext first">Search</span>                                
                            </div> */}                            
                            {/* <div className="tooltips">
                                <img src="images/Home/subscription-icon.png" class="all-three-icons" alt="user-image" />
                                <span class="tooltiptext last">Subscribe</span>
                            </div> */}
                            {/* <div className="tooltips">
                                <img src="images/Home/Accessibility-icon.png" style={{ marginRight: '0px' }} class="all-three-icons" alt="user-image" />
                                <span class="tooltiptext last">Accessibility</span>
                            </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Searchnav
